import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import VisitAttributionObserver from './components/VisitAttributionObserver';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { BrandProvider } from './context/BrandContext';
import { FavouritesProvider } from './context/FavouritesContext';
import { ThemeProvider } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <VisitAttributionObserver />
      <ThemeProvider>
        <AuthProvider>
          <FavouritesProvider>
            <BrandProvider>
              <CartProvider>
                <App />
              </CartProvider>
            </BrandProvider>
          </FavouritesProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
